import Reactotron from 'reactotron-react-js';
import { reactotronRedux } from 'reactotron-redux';
import sagaPlugin from 'reactotron-redux-saga';

if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line
    console.tron = Reactotron;
}

export default (process.env.NODE_ENV === 'development') ? Reactotron
    .configure()
    .use(reactotronRedux())
    .use(sagaPlugin())
    .connect() : () => {};
